export default "__VITE_ASSET__DRLxr71v__"